<template>
  <div class="[&:not(:first-child)]:mt-6 divide-y">
    <slot />
  </div>
</template>
